import type { GridMapboxStyle } from './styles';

export const gridsQuarterSection = (style: GridMapboxStyle) => [
  {
    minzoom: 11.5,
    layout: {
      'text-field': ['get', 'label'],
      'text-size': style.textSize,
      'text-allow-overlap': false,
      'text-ignore-placement': false,
      visibility: 'none',
    },
    type: 'symbol',
    id: 'quarter-section-labels',
    paint: {
      'text-color': style.textColor,
      ...(style.textHaloColor &&
        style.textHaloWidth && {
          'text-halo-color': style.textHaloColor,
          'text-halo-width': style.textHaloWidth,
        }),
    },
    source: 'grids',
    'source-layer': 'qtr_sec_centers',
  },
  {
    minzoom: 11.5,
    type: 'line',
    id: 'quarter-section-grid',
    paint: {
      'line-color': style.lineColor,
      'line-width': style.lineWidth,
    },
    source: 'grids',
    'source-layer': 'qtr_sec',
    layout: {
      visibility: 'none',
    },
  },
];
